export const SORT_TYPE_NONE = 'none'
export const SORT_TYPE_ASC = 'asc'
export const SORT_TYPE_DESC = 'desc'



// WEBPACK FOOTER //
// ./src/components/nexum/constants/sorts.js